import Urls from '../api/Configuration';
import EmptyApiResponse from '../api/dtos/EmptyApiResponse';
import GetUserProfileResponse from '../api/dtos/user/GetUserProfileResponse';
import { UpdatePasswordRequest } from '../api/dtos/user/UpdatePasswordRequest';
import ServiceLocator from './ServiceLocator';

export default class UserProfileService {

    public GetUserProfile(): Promise<GetUserProfileResponse> {
        return ServiceLocator.ApiClient.Get<GetUserProfileResponse>(Urls.USER_PROFILE);
    }

    public UpdateUserName(name: string): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Patch<EmptyApiResponse>(Urls.USER_UPDATE_NAME, { name });
    }

    public UpdateUserPassword(request: UpdatePasswordRequest): Promise<EmptyApiResponse> {
        return ServiceLocator.ApiClient.Patch<EmptyApiResponse>(Urls.USER_UPDATE_PASSWORD, request);
    }

}
